import { endpoints } from "../../../environments/environment";


export const APP_EVENT_DISPATCHER_EVENTS_WHITE_LIST: string[] = [
  endpoints.payments.cipQuery,
  endpoints.accounts.ibPositiveId,
  endpoints.accounts.ibSecurityQuestions
];




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/constants/white-list.constants.ts